import { Box, ButtonProps, SxProps, Theme, alpha, styled } from '@mui/material'
import { FC } from 'react'

interface LoadingOverlayProps {
  color?: ButtonProps['color']
  sx?: SxProps<Theme>
  value: number
}

const LoadingOverlay: FC<LoadingOverlayProps> = ({ color = 'inherit', sx, value = 0 }) => {
  return (
    <StyledBox
      sx={{
        ...sx,
        backgroundColor: (theme) =>
          alpha(color === 'inherit' ? theme.palette.grey[900] : theme.palette[color].main, 0.15),
        width: `${value}%`,
      }}
    />
  )
}

const StyledBox = styled(Box)`
  position: absolute;
  height: 100%;
  top: 0;
  left: 0;
  transition: width 200ms;
`

export default LoadingOverlay
